import { buildApiUrl, buildAssetUrl } from '../../utils/api';
import mockBannersData from '../../data/banners.json';

/**
 * Builds the navigation URL from banner fields:
 *   /products?category_id=X&subcategory_id=Y&search=Z
 */
export const buildBannerUrl = ({ category_id, subcategory_id, search_keyword } = {}) => {
  const params = new URLSearchParams();
  if (category_id)    params.set('category_id',    category_id);
  if (subcategory_id) params.set('subcategory_id', subcategory_id);
  if (search_keyword) params.set('search',         search_keyword);
  const qs = params.toString();
  return qs ? `/products?${qs}` : '/products';
};

const normalizeBanner = (b) => ({
  id:            b.banner_id ?? b.id,
  title:         b.title ?? null,
  image:         buildAssetUrl(b.banner_image ?? b.image ?? ''),
  category_id:   b.category_id   ?? null,
  subcategory_id: b.subcategory_id ?? null,
  search_keyword: b.search_keyword ?? null,
  sort_order:    b.sort_order ?? 0,
  platform:      b.platform ?? 'ALL',
  url:           buildBannerUrl(b),
});

// Convert mock data to match the expected banner format
const getMockBanners = () => {
  return mockBannersData.map((b, i) => ({
    id: b.id,
    image: '',
    category_id: null,
    subcategory_id: null,
    search_keyword: null,
    sort_order: i,
    url: '/products',
  }));
};

export const createBannersSlice = (set) => ({
  banners:         [],
  banners_loading: false,
  banners_error:   null,

  fetchBanners: async () => {
    set({ banners_loading: true, banners_error: null });
    try {
      const res  = await fetch(buildApiUrl('api/v1/customer/banners'));
      const json = await res.json();
      
      // If API fails, use mock data
      if (!res.ok || !json.success) {
        const mockBanners = getMockBanners();
        set({ banners: mockBanners, banners_loading: false, banners_error: null });
        return;
      }

      // Filter: show only WEBSITE and ALL platform banners on the web
      const banners = (json.data ?? [])
        .filter((b) => {
          const p = (b.platform ?? 'ALL').toUpperCase();
          return p === 'WEBSITE' || p === 'ALL';
        })
        .map(normalizeBanner)
        .sort((a, b) => a.sort_order - b.sort_order);

      set({ banners: banners.length > 0 ? banners : getMockBanners(), banners_loading: false });
    } catch (err) {
      // On any error, use mock banners instead of showing error
      const mockBanners = getMockBanners();
      set({ banners: mockBanners, banners_error: null, banners_loading: false });
    }
  },
});
